import React from "react";
import { Link } from "react-router-dom"; // Ako koristiš React Router

function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">
            <div className="container">

                {/* Logo / Natpis */}
                <Link className="navbar-brand fw-bold" to="/">
                    JODUST
                </Link>

                {/* Hamburger za mobile */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Linkovi */}
                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul className="navbar-nav">

                        <li className="nav-item">
                            <Link className="nav-link" to="/">
                                Početna
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to="/katalog">
                                Katalog
                            </Link>
                        </li>


                        <li className="nav-item">
                            <Link className="nav-link" to="/about">
                                O nama
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to="/contact">
                                Kontakt
                            </Link>
                        </li>

                    </ul>
                </div>

            </div>
        </nav>
    );
}

export default Navbar;